import { APIRequest } from '@/app/services/APIRequest';
import compileSchema from '@/app/schema/Compile';
import FocusRef from '@/app/helpers/ForcusRef';
import NotSpaceBar from '@/app/helpers/NotSpaceBar';
import store from '@/app/vuex/store';
import Schema from '@/app/schema/Schema';
import jwt from 'jsonwebtoken';
import { getaccessToken } from '@/app/vuex/getters/auth';
import { mapState } from 'vuex';
import storage from '@/app/configs/storage';
import Navbar from '@/views/components/layouts/Navbar.vue';

export default {
  props: {
    idEdit: String
  },
  components: {
    Navbar
  },
  data: () => ({
    showPassword: false,
    checkRoleSuccess: false,
    email: process.env.VUE_APP_EMAIL_APP,
    userRank: null,
    userRole: null,
    userProvider: null,
    valueInput: {
      username: null,
      password: null,
      firstName: null,
      lastName: null,
      role: null,
      provider: null
    },
    rule:
      {
        username: [
          value => !!value || 'กรุณากรอก ชื่อบัญชีผู้ใช้',
          value => (value && value.length >= 4) || 'ขั้นต่ำ 4 ตัวอักษร'
        ],
        password: [
          value => !!value || 'กรุณากรอก รหัสผ่าน',
          value => (value && value.length >= 4) || 'ขั้นต่ำ 4 ตัวอักษร'
        ],
        firstName: [
          value => !!value || 'กรุณากรอก ชื่อ',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
        ],
        lastName: [
          value => !!value || 'กรุณากรอก นามสกุล',
          value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
        ]
      },
    providerData: []
  }),
  computed: mapState({
    accessToken: getaccessToken
  }),
  mounted(){
    this.getDataProvider();
    if (this.$route && this.$route.name === 'UserCreate'){
      this.checkRoleSuccess = true;
    } else if (this.$route && this.$route.name === 'UserEdit' && this.$props && this.$props.idEdit){
      this.checkRoleEdit();
    }
    const getToken = localStorage.getItem(storage.AUTH_ACCESS_TOKEN);
    const decodeToken = getToken && jwt.decode(localStorage.getItem(storage.AUTH_ACCESS_TOKEN));
    this.userRank = decodeToken && decodeToken.rank;
    this.userRole = decodeToken && decodeToken.role;
    this.userProvider = decodeToken && decodeToken.provider;
  },

  methods: {
    getDataProvider(){
      APIRequest({
        method: 'POST',
        url: '/provider/list-by-query',
        auth: true
      }).then(response => {
        if (response && response.data.code === 10){
          this.providerData = response.data.result;
        }
      }).catch(error => {
        console.log(error);
      });
    },

    handleNotSpaceBar($event){
      const { name, value } = $event.target;
      const valueReturn = NotSpaceBar(value);
      if (name === 'username'){
        this.valueInput.username = valueReturn;
      } else if (name === 'password'){
        this.valueInput.password = valueReturn;
      }
    },

    checkRoleEdit(){
      store.dispatch('loading/setLoading', true);
      const data = {
        id: this.$route.query ? this.$route.query.id : ''
      };
      APIRequest({
        method: 'POST',
        url: '/user/get-user-query-by-id',
        data,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          const userRole = response.data.result.role;
          // console.log('this.userRank : ', this.userRank);
          if (userRole === 'superprovider' && this.userRank < 10){
            this.$router.push({ name: 'User' });
          } else if (userRole === 'admin' && this.userRank < 4){
            this.$router.push({ name: 'User' });
          } else if (userRole === 'user' && this.userRank < 1){
            this.$router.push({ name: 'User' });
          } else {
            this.checkRoleSuccess = true;
            this.getDataEdit();
          }
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    },

    getDataEdit(){
      store.dispatch('loading/setLoading', true);
      const data = {
        id: this.$route.query ? this.$route.query.id : ''
      };
      APIRequest({
        method: 'POST',
        url: '/user/get-user-query-by-id',
        data,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          const userRole = response.data.result.role;
          // console.log('this.userRank : ', this.userRank);
          if (userRole === 'superprovider' && this.userRank < 5){
            this.$router.push({ name: 'User' });
          } else if (userRole === 'admin' && this.userRank < 4){
            this.$router.push({ name: 'User' });
          } else if (userRole === 'user' && this.userRank < 1){
            this.$router.push({ name: 'User' });
          } else {
            this.valueInput.username = userRole !== 'superadmin' ? response.data.result.username.substring(4) : response.data.result.username;
            this.valueInput.password = response.data.result.password;
            this.valueInput.firstName = response.data.result.firstName;
            this.valueInput.lastName = response.data.result.lastName;
            this.valueInput.role = response.data.result.role;
            this.valueInput.provider = response.data.result.provider;
          }
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    },

    handleInsertData(){
      let data;
      let dataProvider;

      const idEdit = {
        id: this.$route.query.id
      };

      // const textProvider = this.valueInput.provider ? this.valueInput.provider.name.substring(0, 4) : '';

      const dataInsert = {
        // username: this.valueInput.username ? textProvider + this.valueInput.username : null,
        username: this.valueInput.username,
        password: this.valueInput.password,
        firstName: this.valueInput.firstName,
        lastName: this.valueInput.lastName,
        role: this.valueInput.role,
        rank: this.userRank
      };

      if (this.userRank === 10){
        dataProvider = {
          // eslint-disable-next-line dot-notation
          provider: this.valueInput.provider ? this.valueInput.provider['_id'] : ''
        };
      } else {
        dataProvider = {
          provider: this.userProvider
        };
      }

      data = {
        ...dataInsert,
        ...dataProvider
      };

      if (this.$route && this.$route.name === 'UserEdit'){
        data = {
          ...idEdit,
          ...dataInsert,
          ...dataProvider
        };
      }

      const compile = compileSchema(data, Schema.User);
      if (compile){
        const forcus = FocusRef(compile);
        if (forcus){
          this.$refs[forcus].focus();
        }
      }

      if (compile.pass === true){
        store.dispatch('loading/setLoading', true);

        let method;
        if (this.$route && this.$route.name === 'UserEdit'){
          method = 'PUT';
        } else {
          method = 'POST';
        }
        APIRequest({
          method,
          url: '/user/',
          data,
          auth: true
        }).then(response => {
          console.log(response);
          if (response && response.data.code === 0){
            this.$router.push({ name: 'User' });
          }
          store.dispatch('loading/setLoading', false);
        }).catch(error => {
          console.log(error);
          store.dispatch('loading/setLoading', false);
        });
      }
    }
  }
};
